import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Switch } from './ui/switch';
import { ImageUpload } from './imageUpload';
import {Coupon } from '../pages/Coupan/index'
interface CouponFormProps {
  onSubmit: (coupon: any) => void;
  editingCoupon: any;
  onCancel: () => void;
}

export function CouponForm({
  onSubmit,
  editingCoupon,
  onCancel,
}: CouponFormProps) {
  const [formData, setFormData] = useState({
    title: '',
    minAmount: 0,
    maxAmount: 0,
    minSpend: 0,
    expiryDate: '',
    status: 'active' as Coupon['status'],
    isNew: true,
    termsAndConditions: '',
    activationStatus: 'pending' as Coupon['activationStatus'],
    maxUsage: 0,
    imageUrl: '',
    coupon_code:"",
    forUsers: 'New Users' as any,

  });

  useEffect(() => {
    if (editingCoupon) {
      setFormData({
        title: editingCoupon.title,
        minAmount: editingCoupon.minAmount,
        maxAmount: editingCoupon.maxAmount,
        minSpend: editingCoupon.minSpend,
        expiryDate: editingCoupon.expiryDate,
        status: editingCoupon.status,
        isNew: editingCoupon.isNew,
        termsAndConditions: editingCoupon.termsAndConditions,
        activationStatus: editingCoupon.activationStatus,
        maxUsage: editingCoupon.maxUsage,
        coupon_code:editingCoupon.coupon_code,
        imageUrl: editingCoupon.imageUrl || '',
    forUsers:editingCoupon.forUsers || 'New Users' ,
        
      });
    }
  }, [editingCoupon]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const expiryDate = new Date(formData.expiryDate);
    const today = new Date();
    const daysLeft = Math.ceil(
      (expiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
    );

    const couponData = {
      ...formData,
      daysLeft,
      minAmount:formData.minAmount|| 0,
      maxAmount:formData.maxAmount|| 0,
      minSpend:formData.minSpend|| 0,
      ...(editingCoupon && { id: editingCoupon.id, usageCount: editingCoupon.usageCount }),
    };

    onSubmit(couponData);
    
    if (!editingCoupon) {
      setFormData({
        title: '',
        minAmount: 0,
        maxAmount: 0,
        minSpend: 0,
        expiryDate: '',
        status: 'active',
        isNew: true,
        termsAndConditions: '',
        activationStatus: 'pending',
    maxUsage: 0,
        imageUrl: '',
        coupon_code:"",
    forUsers: 'New Users' as any,
        
      });
    }
  };

  const handleCancel = () => {
    onCancel();
    setFormData({
      title: '',
      minAmount: 0,
      maxAmount: 0,
      minSpend: 0,
      expiryDate: '',
      status: 'active',
      isNew: true,
      termsAndConditions: '',
      activationStatus: 'pending',
  maxUsage: 0,
      imageUrl: '',
      coupon_code:"",
    forUsers: 'New Users' as any,

    });
  };
  return (
    <Card className="coupon-form-card">
      <CardHeader className="coupon-form-header">
        <CardTitle>
          {editingCoupon ? 'Edit Coupon' : 'Create New Coupon'}
        </CardTitle>
        <p className="text-sm text-gray-500">
          {editingCoupon
            ? 'Update the coupon details below'
            : 'Fill in the details to create a new scratch coupon'}
        </p>
      </CardHeader>
      <CardContent className="coupon-form-content">
        <form onSubmit={handleSubmit} className="coupon-form space-y-6">
          <div className="coupon-form-grid grid grid-cols-1 md:grid-cols-2">
            <div className="space-y-2">
              <Label htmlFor="title">Coupon Title *</Label>
              <Input
                id="title"
                value={formData.title}
                onChange={(e) =>
                  setFormData({ ...formData, title: e.target.value })
                }
                placeholder="e.g., Cashback on Meesho order"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="couponCode">Coupon Code *</Label>
              <Input
                id="couponCode"
                value={formData.coupon_code}
                onChange={(e) =>
                  setFormData({ ...formData, coupon_code: e.target.value })
                }
                placeholder="e.g., COP123"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="expiryDate">Expiry Date *</Label>
              <Input
                id="expiryDate"
                type="date"
                value={formData.expiryDate}
                onChange={(e) =>
                  setFormData({ ...formData, expiryDate: e.target.value })
                }
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="minAmount">Minimum Amount ($) *</Label>
              <Input
                id="minAmount"
                type="number"
                value={formData.minAmount}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    minAmount: Number(e.target.value),
                  })
                }
              
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="maxAmount">Maximum Amount ($) *</Label>
              <Input
                id="maxAmount"
                type="number"
                value={formData.maxAmount}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    maxAmount: Number(e.target.value),
                  })
                }
               
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="minSpend">Minimum Spend ($) *</Label>
              <Input
                id="minSpend"
                type="number"
                value={formData.minSpend}
                onChange={(e) =>
                  setFormData({ ...formData, minSpend: Number(e.target.value) })
                }
              
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="maxUsage">Maximum Usage *</Label>
              <Input
                id="maxUsage"
                type="number"
                value={formData.maxUsage}
                onChange={(e) =>
                  setFormData({ ...formData, maxUsage: Number(e.target.value) })
                }
               
              />
            </div>

         

            <div className="space-y-2">
              <Label htmlFor="activationStatus">Activation Status</Label>
              <Select
                value={formData.activationStatus}
                onValueChange={(value) =>
                  setFormData({
                    ...formData,
                    activationStatus: value as Coupon['activationStatus'],
                  })
                }
              >
                <SelectTrigger id="activationStatus" className="coupon-form-control">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="coupon-select-content">
                  <SelectItem value="pending">Pending</SelectItem>
                  <SelectItem value="activating">Activating</SelectItem>
                  <SelectItem value="activated">Activated</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="forUsers">For Users</Label>
              <Select
                value={formData.forUsers}
                onValueChange={(value) =>
                  setFormData({
                    ...formData,
                    forUsers: value as any,
                  })
                }
              >
                <SelectTrigger id="forUsers" className="coupon-form-control">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="coupon-select-content">
                  <SelectItem value="New Users">New Users</SelectItem>
                  <SelectItem value="All Users">All Users</SelectItem>
                  <SelectItem value="All Homeowners">All Homeowners</SelectItem>
                  <SelectItem value="New Homeowners">New Homeowners</SelectItem>
                  <SelectItem value="All Contractor">All Contractor</SelectItem>
                  <SelectItem value="New Contractor">New Contractor</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="space-y-2">
            <Label>Coupon Image (Optional)</Label>
            <ImageUpload
              value={formData.imageUrl}
              onChange={(url,pathUrl) => {
                if(pathUrl){
                  setFormData({ ...formData, imageUrl: pathUrl })

                }
              }}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="terms">Terms & Conditions *</Label>
            <Textarea
              id="terms"
              value={formData.termsAndConditions}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  termsAndConditions: e.target.value,
                })
              }
              placeholder="Enter terms and conditions..."
              rows={4}
              required
            />
          </div>

          <div className="coupon-new-toggle flex items-center">
            <Switch
              id="isNew"
              className="coupon-new-switch"
              checked={formData.isNew}
              onCheckedChange={(checked) =>
                setFormData({ ...formData, isNew: checked })
              }
            />
            <Label htmlFor="isNew" className="cursor-pointer">
              Mark as "New" coupon
            </Label>
          </div>

          <div className="coupon-form-actions flex gap-3">
            <Button type="submit" className="coupon-submit-button">
              {editingCoupon ? 'Update Coupon' : 'Create Coupon'}
            </Button>
            {editingCoupon && (
              <Button
                type="button"
                variant="outline"
                onClick={handleCancel}
                className="coupon-cancel-button"
              >
                Cancel
              </Button>
            )}
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
